import { env } from '@/config/env';

/** Raster nền (XYZ PNG) — cùng họ với traffic `api/tf/…` trong tài liệu Vietmap; override bằng env nếu console trả URL khác. */
const DEFAULT_VIETMAP_RASTER_TILE_PATH_TEMPLATE = 'https://maps.vietmap.vn/api/tm/{z}/{x}/{y}.png';

export type VietmapVectorStyleId = 'tm' | 'lm' | 'dm';

/**
 * URL style vector cho react-map-gl (runtime: `@vietmap/vietmap-gl-js` thay cho maplibre-gl).
 *
 * @param style - Mặc định lấy từ {@link env.VIETMAP_VECTOR_STYLE} (`VITE_VIETMAP_VECTOR_STYLE`).
 *   `tm` — nền thường; `lm` — light; `dm` — dark (Web SDK v6+).
 * @returns `style.json` kèm `apikey` (query).
 */
export function getVietmapVectorStyleUrl(style?: VietmapVectorStyleId): string {
  const resolved: VietmapVectorStyleId = style ?? env.VIETMAP_VECTOR_STYLE;
  const key = env.VIETMAP_TILEMAP_KEY;
  if (!key) {
    console.warn('[Vietmap] VITE_VIETMAP_TILEMAP_KEY trống; tile có thể lỗi.');
  }
  return `https://maps.vietmap.vn/maps/styles/${resolved}/style.json?apikey=${encodeURIComponent(key)}`;
}

/**
 * URL đầy đủ cho `UrlTemplateImageryProvider` (Cesium): giữ `{z}` `{x}` `{y}`; `apikey` đã gắn vào query.
 * Ưu tiên `VITE_VIETMAP_RASTER_TILE_URL_TEMPLATE` nếu set (có thể dùng `{apikey}` trong chuỗi).
 */
export function getVietmapRasterTileUrlTemplate(): string {
  const key = env.VIETMAP_TILEMAP_KEY;
  if (!key) {
    console.warn('[Vietmap] VITE_VIETMAP_TILEMAP_KEY trống; tile raster Cesium có thể lỗi.');
  }

  const override = (import.meta.env.VITE_VIETMAP_RASTER_TILE_URL_TEMPLATE ?? '').trim();

  if (override !== '') {
    return applyVietmapRasterOverride(override, key);
  }

  return `${DEFAULT_VIETMAP_RASTER_TILE_PATH_TEMPLATE}?apikey=${encodeURIComponent(key)}`;
}

function applyVietmapRasterOverride(template: string, apiKey: string): string {
  if (template.includes('{apikey}')) {
    return template.split('{apikey}').join(encodeURIComponent(apiKey));
  }
  const sep = template.includes('?') ? '&' : '?';
  return `${template}${sep}apikey=${encodeURIComponent(apiKey)}`;
}
